export default __webpack_public_path__ + "static/novus_bg-f7083e4c92222dafac257b5acad47476.png";